// Pure: compute the scrollTop needed to bring a card into view, or null if it's already
// fully visible. All values in the scroll container's content coordinates:
//   cardTop/cardHeight — the card's laid-out position + height (NOT its live/animating rect,
//     which is stale during the CSS top-transition — that's the bug this avoids)
//   viewTop = container.scrollTop, viewHeight = container.clientHeight
// Triggers only when the card is actually off-screen; leaves a `margin` gap when it scrolls.
export function scrollTargetTop({ cardTop, cardHeight, viewTop, viewHeight, margin = 24 }) {
  const cardBottom = cardTop + cardHeight;
  const viewBottom = viewTop + viewHeight;
  if (cardTop < viewTop) return Math.max(0, cardTop - margin);              // above the fold
  if (cardBottom > viewBottom) return Math.max(0, cardTop + cardHeight + margin - viewHeight); // below
  return null;                                                             // fully in view
}

// Explicit "recenter": scrollTop that centers the card vertically in the viewport,
// regardless of whether it's currently visible. Clamped at 0.
export function centerScrollTop({ cardTop, cardHeight, viewHeight }) {
  return Math.max(0, Math.round(cardTop + cardHeight / 2 - viewHeight / 2));
}

// scrollTop that TOP-aligns a tall element (a journey panel spans the whole journey, so
// centering it lands in its middle — for a journey you want its top: header + first cards).
// Leaves a small margin above and clamps at 0.
export function journeyTopScroll(panelTop, margin = 24) {
  return Math.max(0, Math.round(panelTop - margin));
}

// scrollLeft that centers the card in the viewport region NOT covered by the editor
// drawer on the right (rightInset px). cardCenterX is the card's center (cards are
// positioned at `left: x` with translateX(-50%), so x IS the center). Clamped at 0.
export function centerScrollLeft({ cardCenterX, viewWidth, rightInset = 0 }) {
  const visibleCenter = (viewWidth - rightInset) / 2;
  return Math.max(0, Math.round(cardCenterX - visibleCenter));
}
